export default {"src":"/_next/static/media/point-circle-color.7b2ed637.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};